/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Stock_AdjustmentsInputs */

const en_nav_stock_adjustments = /** @type {(inputs: Nav_Stock_AdjustmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock adjustments`)
};

/**
* | output |
* | --- |
* | "Stock adjustments" |
*
* @param {Nav_Stock_AdjustmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_stock_adjustments = /** @type {((inputs?: Nav_Stock_AdjustmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Stock_AdjustmentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_stock_adjustments(inputs)
});